import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {SharedMaterialModule} from '../../shared/shared-material.module';
import {LoginComponent} from './login/login.component';
import {PasswordComponent} from './password/password.component';


@NgModule({
  imports: [
    SharedModule,
    SharedMaterialModule
  ],
  declarations: [
    LoginComponent,
    PasswordComponent
  ],
  providers: [
  ],
  exports: [
    LoginComponent,
    PasswordComponent
  ]
})
export class PagesModule {
}
